// What's new, once per account after an update (src/help/news.ts): a short card in the corner home with up to three
// lines, each with Try it, and a way to put it away. Seen on one device, it never shows on another.

import { X } from "lucide-react";
import { sawNews, useOnboarding } from "../state/onboarding";
import { useStore } from "../state/store";
import { runHelpAction } from "./actions";
import { latestNews, versionTime } from "./news";
import { useHoldTips } from "./cards";
import "./chrome.css";

/** The note to show now, or null: a version this account has not seen, made after the account was. */
export function useNews() {
  const seen = useOnboarding((o) => o.news?.id ?? null);
  const made = useStore((s) => s.workspace?.createdAt ?? 0);
  const news = latestNews();
  if (!news || seen === news.version || !made || made >= versionTime(news.version)) return null;
  return news;
}

export function WhatsNew({ news }: { news: NonNullable<ReturnType<typeof latestNews>> }) {
  // the first-time tips wait while it is on screen (fix round 1)
  useHoldTips();
  return (
    <section className="news-card island" data-news={news.version} aria-label="What's new">
      <div className="away-head">
        <div>
          <h3>What's new</h3>
          <span className="away-since">{news.date}</span>
        </div>
        <button className="icon-btn sm" aria-label="Dismiss" data-tip="Dismiss" data-news-dismiss onClick={() => sawNews(news.version)}>
          <X size={14} />
        </button>
      </div>
      <ul className="news-lines">
        {news.lines.map((l) => (
          <li key={l.text}>
            <span>{l.text}</span>
            <button
              className="news-try"
              onClick={() => {
                sawNews(news.version);
                runHelpAction(l.go);
              }}
            >
              Try it
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
